import { useTranslation } from 'next-i18next'
import { Submit } from '@captaincause/ui/Button/Submit'
import type { Campaign, Project } from '@captaincause/types'
import type { TFunction } from 'i18next'

interface DonateButtonProps {
  campaign: Campaign
  project: Project
  isFirstFrame?: boolean
  isDisabled: boolean
  pointsMode: boolean
}

function getLabel(
  campaign: Campaign,
  project: Project,
  pointsMode: boolean,
  t: TFunction<'give.page'>,
) {
  if (campaign.is_consult) {
    return t('donate.form.submit.consult')
  }

  if (pointsMode) {
    return t('donate.form.submit.points')
  }

  return t('donate.form.submit')
}

export function DonateButton({
  campaign,
  project,
  pointsMode,
  isDisabled,
  isFirstFrame = false,
}: DonateButtonProps) {
  const { t } = useTranslation(['give.page', 'common'])
  const label = getLabel(campaign, project, pointsMode, t)

  return (
    <div className="flex w-full justify-center">
      <Submit
        variant="primary"
        className="w-full"
        disabled={isFirstFrame || isDisabled}
        style={{ boxShadow: '0px 0px 4px 2px #A19CDE' }}
      >
        {label}
      </Submit>
    </div>
  )
}
